/*
 * Copyright (c) 2022
 * 
 * Created Date: Tuesday, October 4th 2022, 12:16:00 pm
 * Author: Muhammad Fajariansyah Ismail
 * 
 */

import IconCopyToClipboard from 'assets/icons/IconCopyToClipboard';
import React, { useState } from 'react';
import Clipboard from 'react-clipboard.js';
import { useTranslation } from "react-i18next"
import { isCopySupported } from 'utils/Helper';
import RollbarConfig from "utils/RollbarConfig";


const CopyToClipboardText = ({ url }) => {

    const [isCopied, setIsCopied] = useState(false)

    const {t} = useTranslation()

    const handleError = (error) => {
        RollbarConfig.error(`Failed copy to clipboard`, {
            'textOrigin': url,
            'errorMessage': error,
        })
        console.log(error)
    }

    return <div className='copy-to-clipboard-text-root-container'>
        {
            isCopySupported() ? (
                <div className='copy-to-clipboard-text-container'>
                    <input type='text' value={url} readOnly />
                    <Clipboard component="button" className='btn-copy' onSuccess={()=>{setIsCopied(true)}} onError={handleError} button-href="#" data-clipboard-text={url}>
                        <IconCopyToClipboard />
                    </Clipboard>
                </div>
            ) : (
                <div className='copy-to-clipboard-text-container text-left' dangerouslySetInnerHTML={{ __html: url }}></div>
            )
        }
        <p className={`copy-to-clipboard-text-hint ${!isCopied ? 'invisible' : ''}`}>{t('common.copyToClipboard')}</p>
    </div>
}

export default CopyToClipboardText
